module.exports = __webpack_public_path__ + "static/media/spaceman.5e8272d7.png";